module.exports = __webpack_public_path__ + "static/media/delivery.970bac8f.svg";